module.exports = __webpack_public_path__ + "img/slide_5.79c4243f.jpg";